export default __webpack_public_path__ + "static/media/signupSVG.ec04b86f.svg";